import { type Column } from "@tanstack/react-table";
import { ArrowDownIcon, ArrowUpDownIcon, ArrowUpIcon } from "lucide-react";
import * as React from "react";

type SortableHeaderProps<TData> = {
  readonly column: Column<TData>;
  readonly children: React.ReactNode;
};

export const SortableHeader = <TData,>({ children, column }: SortableHeaderProps<TData>) => {
  const sortDirection = column.getIsSorted();

  const SortIcon = React.useMemo(
    () =>
      sortDirection === "asc"
        ? <ArrowUpIcon className="size-3 shrink-0" />
        : sortDirection === "desc"
        ? <ArrowDownIcon className="size-3 shrink-0" />
        : <ArrowUpDownIcon className="size-3 shrink-0 opacity-50" />,
    [sortDirection],
  );

  return (
    <button
      type="button"
      onClick={column.getToggleSortingHandler()}
      className="inline-flex items-center gap-1 font-medium text-left cursor-pointer hover:text-foreground"
      title={column.getCanSort()
        ? column.getNextSortingOrder() === "asc"
          ? "Sort ascending"
          : column.getNextSortingOrder() === "desc"
          ? "Sort descending"
          : "Clear sort"
        : undefined}
    >
      {children}
      {SortIcon}
    </button>
  );
};
